import React from 'react'
import { Customer } from '../../../../helpers/models/Models';
import { useLanguage } from '../../../../context/LanguageProvider';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../store/store';
import { NepNowDateFormat } from '../../../../constants/DateFormat';
import { NumberToNepaliNum } from '../../../../helpers/DateFormat';
import AppURL from '../../../../constants/AppURL';
interface PrintCustomerListProps {
    data: {
        results: Customer[];
        previous: string | null;
        next: string | null;
    } | null;
}
const PrintListCustomerList: React.FC<PrintCustomerListProps> = ({ data }) => {
    const { SOFTWARE_ORG, ACCOUNT_RPT_DATE } = useSelector((state: RootState) => state.software);
    const org_details = SOFTWARE_ORG?.org;
    const date_report = ACCOUNT_RPT_DATE.acc_rpt;
    const { language } = useLanguage();
    const DateNow = NepNowDateFormat();
    return (
        <div className='p-5 bg-white h-screen'>
            <div className="relative border border-gray-300 p-0.5">
                <table className="w-full text-sm text-left rtl:text-right text-black">
                    <tbody>
                        <tr>
                            <td className={`w-[25%] text-[12px] text-black whitespace-nowrap ${language === "Eng" ? "font-public-sans" : "font-nepali"}`} >
                                {language === "Eng" ? "S. Code: " : "एस. कोड:"}:  {language === "Eng" ? org_details?.org_reg : NumberToNepaliNum(org_details?.org_reg || "")}
                            </td>
                            <td className="w-[25%]">
                            </td>
                            <td className="w-[25%]">
                            </td>
                            <td align='right' className={`w-[25%] text-[12px] text-black whitespace-nowrap ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                                {language === "Eng" ? "Phone: " : "फोन नम्बर:"}  {language === "Eng" ? org_details?.org_phone : NumberToNepaliNum(org_details?.org_phone || 0)}
                            </td>
                        </tr>
                        <tr >
                            <td rowSpan={4} className="w-[25%] font-medium text-black whitespace-nowrap dark:text-white">
                                <img width={60} height={60} src={AppURL.BaseURL + org_details?.logo} alt="" />
                            </td>
                            <td align='center' colSpan={2} className={`w-[25%] text-black font-bold text-[18px] ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                                {language === "Eng" ? org_details?.org_name : org_details?.org_name_nep}
                            </td>
                            <td className="w-[25%]">
                            </td>
                        </tr>
                        <tr >
                            <td align='center' colSpan={2} className={`w-[25%] text-black font-normal text-[12px] ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                                {language === "Eng" ? org_details?.org_add : org_details?.org_add_nep}
                            </td>
                            <td align='right' className={`w-[25%] text-[11px] text-black font-normal ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                            </td>
                        </tr>
                        <tr >
                            <td align='center' colSpan={2} className={`w-[25%] underline text-black font-thin text-[15px] ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                                {language === "Eng" ? "Customers List Report" : "ग्राहकहरूको सूची रिपोर्ट"}
                            </td>
                            <td className="w-[25%]">
                            </td>
                        </tr>
                        <tr>
                            <td align='center' colSpan={2} className={`w-[25%] text-black font-light text-[11px] ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                                {language === "Eng" ? "Date: " : "मिति: "} {language === "Eng" ? DateNow : NumberToNepaliNum(DateNow)}
                            </td>
                            <td align='right' className="w-[25%] text-[11px]">
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className={`relative`}>
                <table className="w-full text-left rtl:text-right text-black ">
                    <thead className="text-[10px]  font-light text-gray700 bg-slate-100 dark:bg-sky-950 capitalize border-b dark:bg-slate900 dark:text-slate-400">
                        <tr>
                            <th scope="col" align='center' className={`px-1 border border-slate-300 dark:border-sky-800 ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                                {language === "Eng" ? "S.N." : "स.नं."}
                            </th>
                            <th scope="col" align='center' className={`px-1 border border-slate-300 dark:border-sky-800 ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                                {language === "Eng" ? "Member Name" : "सदस्यको नाम"}
                            </th>
                            <th scope="col" align='center' className={`px-1 border border-slate-300 dark:border-sky-800 ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                                {language === "Eng" ? "Spouse Name" : "पति/पत्नीको नाम"}
                            </th>
                            <th scope="col" align='center' className={`px-1 border border-slate-300 dark:border-sky-800 ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                                {language === "Eng" ? "Tole/Marga" : "टोले/मार्ग"}
                            </th>
                            <th scope="col" align='center' className={`px-1 border border-slate-300 dark:border-sky-800 ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                                {language === "Eng" ? "Address" : "ठेगाना"}
                            </th>
                            <th scope="col" align='center' className={`px-1 border border-slate-300 dark:border-sky-800 ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                                {language === "Eng" ? "Phone No" : "फोन नं."}
                            </th>
                            <th scope="col" align='center' className={`px-1 border border-slate-300 dark:border-sky-800 ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                                {language === "Eng" ? "Tap No." : "धारा नम्बर"}
                            </th>
                            <th scope="col" align='center' className={`px-1 border border-slate-300 dark:border-sky-800 ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                                {language === "Eng" ? "Tap Status" : "धारा स्थिति"}
                            </th>
                            <th scope="col" align='center' className={`px-1 border border-slate-300 dark:border-sky-800 ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                                {language === "Eng" ? "Conn. Date" : "धारा जडान मिति"}
                            </th>
                        </tr>
                    </thead>
                    <tbody className={`text-slate-800 text-[10px] ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                        {Array.isArray(data?.results) &&
                            data?.results?.map((member: Customer, index: number) =>
                            (
                                <tr key={index}>
                                    <td align='center' className={`px-1 border border-gray-300 font-light dark:border-sky-800 capitalize ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                                        {language === "Eng" ? index + 1 : NumberToNepaliNum(index + 1)}.
                                    </td>
                                    <td align='left' className={`px-1 border border-gray-300 font-light dark:border-sky-800 capitalize ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                                        {language === "Eng" ? member.mem_name : member.mem_name_nep}
                                    </td>
                                    <td align='left' className={`px-1 border border-gray-300 font-light dark:border-sky-800 capitalize ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                                        {language === "Eng" ? member.spouse_name : member.spouse_name_nep}
                                    </td>
                                    <td align='left' className={`px-1 border border-gray-300 font-light dark:border-sky-800 ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                                        {language === "Eng" ? member.tole_name : member.tole_name_nep}
                                    </td>
                                    <td align='left' className={`px-1 border border-gray-300 font-light dark:border-sky-800 ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                                        {language === "Eng" ? member.add_eng : member.add_nep}
                                    </td>
                                    <td align='left' className={`px-1 border border-gray-300 font-light dark:border-sky-800 ${language === "Eng" ? "font-public-sans" : "font-nepali tracking-tighter"}`}>
                                        {language === "Eng" ? member.phone_no : NumberToNepaliNum(member.phone_no || 0)}
                                    </td>
                                    <td align='left' className={`px-1 border border-gray-300 font-light dark:border-sky-800 ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                                        {language === "Eng" ? member.tap_no : member.tap_no}
                                    </td>
                                    <td align='left' className={`px-1 border border-gray-300 font-light dark:border-sky-800 ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                                        {language === "Eng" ? member.tap_status === 1 ? "Bigreko" : member.tap_status === 2 ? "Khapat Nabhayako " : member.tap_status === 3 ? "Sewa Banda" : "No Status" : member.tap_status === 1 ? "बिग्रेको" : member.tap_status === 2 ? "खपत नभयको" : member.tap_status === 3 ? "सेवा बन्द भयको" : "छैन"}
                                    </td>
                                    <td align='left' className={`px-1 border border-gray-300 font-light dark:border-sky-800 ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                                        {language === "Eng" ? member.meter_conn_date : NumberToNepaliNum(member.meter_conn_date || "-")}
                                    </td>
                                </tr>
                            )
                            )
                        }

                    </tbody>
                </table>
            </div>
        </div>
    )
}

export default PrintListCustomerList